import { getGroups as getAllGroups, getPurposesPages } from '../api/groupsPurposesPages';
import { beautifyPageNames, filterPurposesByGroup } from '../utils/filterGroupsPurposesPages';
import { ADD_PAGES_DATA } from './pages';
import { ADD_PURPOSE_DATA } from './purposes';

const ADD_GROUP_DATA = 'ADD_GROUP_DATA';
const MARK_GROUPS_LOADED = 'MARK_GROUPS_LOADED';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';

const INITIAL_STATE = {
  isLoaded: false,
  groups: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_GROUP_DATA:
      return {
        ...state,
        groups: [...action.payload],
      };
    case MARK_GROUPS_LOADED:
      return {
        ...state,
        isLoaded: true,
      };
    case CLEAR_GROUPS:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export function getGroups() {
  return async (dispatch) => {
    try {
      const groups = await getAllGroups();
      const purposesPages = await getPurposesPages();

      const pages = beautifyPageNames(purposesPages[0].pageDashboard);
      const groupsAndPurposes = filterPurposesByGroup(groups, pages);

      dispatch({
        type: ADD_GROUP_DATA,
        payload: groups,
      });

      dispatch({ type: MARK_GROUPS_LOADED });

      dispatch({
        type: ADD_PAGES_DATA,
        payload: pages,
      });

      dispatch({
        type: ADD_PURPOSE_DATA,
        payload: groupsAndPurposes,
      });

      return Promise.resolve({ groups, groupsAndPurposes, pages });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
